import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {},

  contentWrapper: {
    paddingTop: 20,
    paddingHorizontal: 40,
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
    textAlign: 'left',
  },
  description: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 'normal',
    lineHeight: 1.4,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    borderRadius: 2,
    paddingVertical: 5,

    marginTop: 20,
    marginBottom: 60,

    width: 112,
  },
  linkText: {
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 9,
    textDecoration: 'none',
  },
  imageRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
    height: 130,
    width: '100%',
  },
  topImage: {
    width: '100%',
    height: 325,
    objectFit: 'cover',
    borderRadius: 4,
    marginBottom: 10,
  },
  thumbnail: {
    width: '33%',
    height: 142,
    objectFit: 'cover',
    borderRadius: 4,
  },
});
